var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreferences(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#E8E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4375 23.75C25.857 23.75 23.75 25.857 23.75 28.4375C23.75 31.018 25.857 33.125 28.4375 33.125H41.5625C44.1402 33.125 46.25 31.0152 46.25 28.4375C46.25 25.8598 44.1402 23.75 41.5625 23.75H28.4375ZM28.4375 25.625H37.84C37.2432 26.4116 36.875 27.38 36.875 28.4375C36.875 29.495 37.2432 30.4634 37.84 31.25H28.4375C26.863 31.25 25.625 30.012 25.625 28.4375C25.625 26.863 26.863 25.625 28.4375 25.625ZM41.5625 25.625C43.1269 25.625 44.375 26.8731 44.375 28.4375C44.375 30.0019 43.1269 31.25 41.5625 31.25C39.9981 31.25 38.75 30.0019 38.75 28.4375C38.75 26.8731 39.9981 25.625 41.5625 25.625Z",
    fill: "#08056D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4375 36.875C25.8598 36.875 23.75 38.9848 23.75 41.5625C23.75 44.1402 25.8598 46.25 28.4375 46.25H41.5625C44.143 46.25 46.25 44.143 46.25 41.5625C46.25 38.982 44.143 36.875 41.5625 36.875H28.4375ZM28.4375 38.75C30.0019 38.75 31.25 39.9981 31.25 41.5625C31.25 43.1269 30.0019 44.375 28.4375 44.375C26.8731 44.375 25.625 43.1269 25.625 41.5625C25.625 39.9981 26.8731 38.75 28.4375 38.75ZM32.16 38.75H41.5625C43.137 38.75 44.3768 39.988 44.3768 41.5625C44.3768 43.137 43.137 44.375 41.5625 44.375H32.16C32.7568 43.5884 33.125 42.62 33.125 41.5625C33.125 40.505 32.7568 39.5366 32.16 38.75Z",
    fill: "#08056D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/Preferences.4f8e4cacf61aa09296fad16b190b82b1.svg";
export { ForwardRef as ReactComponent };